import React from 'react';
import Icon from '../../../components/AppIcon';

const WellnessInsights = ({ insights, challenges }) => {
  return (
    <div className="bg-card rounded-lg border border-border p-6 shadow-wellness">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-xl font-heading font-semibold text-foreground">Wellness Insights</h2>
        <Icon name="Brain" size={20} className="text-primary" />
      </div>
      {/* Personal Insights */}
      <div className="mb-6">
        <h3 className="text-lg font-heading font-medium text-foreground mb-3">Your Insights</h3>
        <div className="space-y-3">
          {insights?.map((insight, index) => (
            <div key={index} className="flex items-start space-x-3 p-3 rounded-lg bg-muted/30 border border-border">
              <div className={`w-8 h-8 ${insight?.type === 'positive' ? 'bg-success' : insight?.type === 'warning' ? 'bg-warning' : 'bg-primary'} rounded-full flex items-center justify-center flex-shrink-0`}>
                <Icon 
                  name={insight?.type === 'positive' ? 'TrendingUp' : insight?.type === 'warning' ? 'AlertTriangle' : 'Info'} 
                  size={16} 
                  color="white" 
                />
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-sm font-medium text-foreground">{insight?.title}</p>
                <p className="text-xs text-muted-foreground mt-1">{insight?.description}</p>
                <div className="flex items-center space-x-2 mt-2">
                  <Icon name="Clock" size={12} className="text-muted-foreground" />
                  <span className="text-xs text-muted-foreground">{insight?.timeframe}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      {/* Active Challenges */}
      <div>
        <h3 className="text-lg font-heading font-medium text-foreground mb-3">Active Challenges</h3>
        <div className="space-y-3">
          {challenges?.map((challenge, index) => (
            <div 
              key={index}
              onClick={() => window.location.href = '/community-forums?section=challenges'}
              className="flex items-center space-x-3 p-3 rounded-lg border border-border hover:border-accent/20 hover:bg-accent/5 transition-wellness cursor-pointer"
            >
              <div className="w-10 h-10 bg-accent rounded-lg flex items-center justify-center flex-shrink-0">
                <Icon name="Trophy" size={18} color="white" />
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-sm font-medium text-foreground">{challenge?.name}</p>
                <div className="flex items-center space-x-4 mt-1">
                  <div className="flex items-center space-x-1">
                    <Icon name="Users" size={12} className="text-muted-foreground" />
                    <span className="text-xs text-muted-foreground">{challenge?.participants} participants</span>
                  </div>
                  <div className="flex items-center space-x-1">
                    <Icon name="Calendar" size={12} className="text-muted-foreground" />
                    <span className="text-xs text-muted-foreground">{challenge?.daysLeft} days left</span>
                  </div>
                </div>
                <div className="mt-2">
                  <div className="w-full bg-muted rounded-full h-1.5">
                    <div 
                      className="bg-accent h-1.5 rounded-full transition-all duration-500 ease-out"
                      style={{ width: `${challenge?.progress}%` }}
                    ></div>
                  </div>
                  <p className="text-xs text-muted-foreground mt-1">{challenge?.progress}% complete</p>
                </div>
              </div>
              <Icon name="ChevronRight" size={16} className="text-muted-foreground" />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default WellnessInsights;